import { BuildingInfo } from './MapIframe';
import { Product, ProductCategory } from '../components/ProductsSelection';
import { FactsTableRow, FactsTableRowType } from '../components/elements/FactsTable';
import { CalculatorUtil } from './CalculatorUtil';

export class CalculatorData {

    public static getCostTableRows(buildingInfo: BuildingInfo | null, selectedProduct: Product | null): FactsTableRow[] {

        if (!buildingInfo) {
            return [];
        }

        const estimatedCost = (buildingInfo?.totalInCartArea3DM2 || 0) * (selectedProduct?.priceCoefficient || 1);
        const segmentsCount = CalculatorUtil.getSegmentsCount(buildingInfo);

        return [
            {
                title: 'Roof area',
                value: CalculatorUtil.formatNumber(buildingInfo?.totalInCartArea3DM2) + ' m²',
                type: FactsTableRowType.SMALL,
            },
            {
                title: 'Roof sides',
                value: segmentsCount,
                type: FactsTableRowType.SMALL,
            },
            {
                title: 'Estimated cost',
                value: CalculatorUtil.formatNumber(estimatedCost) + ' €',
                type: FactsTableRowType.TOTAL,
            },

        ] as FactsTableRow[];

    }

    public static getSolarTableRows(buildingInfo: BuildingInfo | null, selectedProduct: Product | null) {

        if (!buildingInfo) {
            return [];
        }

        const capacity = (buildingInfo?.totalInCartArea3DM2 || 0) * (selectedProduct?.capacityCoefficient || 1);

        return [
            {
                title: 'Annual productivity',
                value: CalculatorUtil.formatNumber(buildingInfo?.totalInCartProductivityKwhPerYear, 0) + ' kWh',
            },
            {
                title: 'Capacity',
                value: CalculatorUtil.formatNumber(capacity, 0) + ' W',
            },

        ] as FactsTableRow[];
    }

    public static getProductTableRows(buildingInfo: BuildingInfo | null, selectedProduct: Product | null) {

        switch (selectedProduct?.category) {

            case ProductCategory.SOLAR:
                return CalculatorData.getSolarTableRows(buildingInfo, selectedProduct);

            default:
                return [];
        }

    }

}